{
  "countries": {
    "AFG": {
      "countryName": "Afghanistan",
      "characterSets": [],
      "phoneCode": "+93"
    },
    "ALA": {
      "countryName": "Åland Islands",
      "characterSets": [],
      "phoneCode": "+358 18"
    },
    "ALB": {
      "countryName": "Albania",
      "characterSets": [],
      "phoneCode": "+355"
    },
    "DZA": {
      "countryName": "Algeria",
      "characterSets": [
        "arabic"
      ],
      "phoneCode": "+213"
    },
    "ASM": {
      "countryName": "American Samoa",
      "characterSets": [],
      "phoneCode": "+1 684"
    },
    "AND": {
      "countryName": "Andorra",
      "characterSets": [],
      "phoneCode": "+376"
    },
    "AGO": {
      "countryName": "Angola",
      "characterSets": [],
      "phoneCode": "+244"
    },
    "AIA": {
      "countryName": "Anguilla",
      "characterSets": [],
      "phoneCode": "+1 264"
    },
    "ATA": {
      "countryName": "Antarctica",
      "characterSets": [],
      "phoneCode": ""
    },
    "ATG": {
      "countryName": "Antigua and Barbuda",
      "characterSets": [],
      "phoneCode": "+1 268"
    },
    "ARG": {
      "countryName": "Argentina",
      "characterSets": [],
      "phoneCode": "+54"
    },
    "ARM": {
      "countryName": "Armenia",
      "characterSets": [],
      "phoneCode": "+374"
    },
    "ABW": {
      "countryName": "Aruba",
      "characterSets": [],
      "phoneCode": "+297"
    },
    "AUS": {
      "countryName": "Australia",
      "characterSets": [],
      "phoneCode": "+61"
    },
    "AUT": {
      "countryName": "Austria",
      "characterSets": [],
      "phoneCode": "+43"
    },
    "AZE": {
      "countryName": "Azerbaijan",
      "characterSets": [],
      "phoneCode": "+994"
    },
    "BHS": {
      "countryName": "Bahamas",
      "characterSets": [],
      "phoneCode": "+1 242"
    },
    "BHR": {
      "countryName": "Bahrain",
      "characterSets": [
        "arabic"
      ],
      "phoneCode": "+973"
    },
    "BGD": {
      "countryName": "Bangladesh",
      "characterSets": [],
      "phoneCode": "+880"
    },
    "BRB": {
      "countryName": "Barbados",
      "characterSets": [],
      "phoneCode": "+1 246"
    },
    "BLR": {
      "countryName": "Belarus",
      "characterSets": [
        "cyrillic"
      ],
      "phoneCode": "+375"
    },
    "BEL": {
      "countryName": "Belgium",
      "characterSets": [],
      "phoneCode": "+32"
    },
    "BLZ": {
      "countryName": "Belize",
      "characterSets": [],
      "phoneCode": "+501"
    },
    "BEN": {
      "countryName": "Benin",
      "characterSets": [],
      "phoneCode": "+229"
    },
    "BMU": {
      "countryName": "Bermuda",
      "characterSets": [],
      "phoneCode": "+1 441"
    },
    "BTN": {
      "countryName": "Bhutan",
      "characterSets": [],
      "phoneCode": "+975"
    },
    "BOL": {
      "countryName": "Bolivia, Plurinational State of",
      "characterSets": [],
      "phoneCode": "+591"
    },
    "BES": {
      "countryName": "Bonaire, Sint Eustatius and Saba",
      "characterSets": [],
      "phoneCode": "+599 7"
    },
    "BIH": {
      "countryName": "Bosnia and Herzegovina",
      "characterSets": [
        "cyrillic"
      ],
      "phoneCode": "+387"
    },
    "BWA": {
      "countryName": "Botswana",
      "characterSets": [],
      "phoneCode": "+267"
    },
    "BVT": {
      "countryName": "Bouvet Island",
      "characterSets": [],
      "phoneCode": ""
    },
    "BRA": {
      "countryName": "Brazil",
      "characterSets": [],
      "phoneCode": "+55"
    },
    "IOT": {
      "countryName": "British Indian Ocean Territory",
      "characterSets": [],
      "phoneCode": "+246"
    },
    "BRN": {
      "countryName": "Brunei Darussalam",
      "characterSets": [],
      "phoneCode": "+673"
    },
    "BGR": {
      "countryName": "Bulgaria",
      "characterSets": [
        "cyrillic"
      ],
      "phoneCode": "+359"
    },
    "BFA": {
      "countryName": "Burkina Faso",
      "characterSets": [],
      "phoneCode": "+226"
    },
    "BDI": {
      "countryName": "Burundi",
      "characterSets": [],
      "phoneCode": "+257"
    },
    "KHM": {
      "countryName": "Cambodia",
      "characterSets": [],
      "phoneCode": "+855"
    },
    "CMR": {
      "countryName": "Cameroon",
      "characterSets": [],
      "phoneCode": "+237"
    },
    "CAN": {
      "countryName": "Canada",
      "characterSets": [],
      "phoneCode": "+1"
    },
    "CPV": {
      "countryName": "Cape Verde",
      "characterSets": [],
      "phoneCode": "+238"
    },
    "CYM": {
      "countryName": "Cayman Islands",
      "characterSets": [],
      "phoneCode": "+1 345"
    },
    "CAF": {
      "countryName": "Central African Republic",
      "characterSets": [],
      "phoneCode": "+236"
    },
    "TCD": {
      "countryName": "Chad",
      "characterSets": [
        "arabic"
      ],
      "phoneCode": "+235"
    },
    "CHL": {
      "countryName": "Chile",
      "characterSets": [],
      "phoneCode": "+56"
    },
    "CHN": {
      "countryName": "China",
      "characterSets": [],
      "phoneCode": "+86"
    },
    "CXR": {
      "countryName": "Christmas Island",
      "characterSets": [],
      "phoneCode": "+61"
    },
    "CCK": {
      "countryName": "Cocos (Keeling) Islands",
      "characterSets": [],
      "phoneCode": "+61"
    },
    "COL": {
      "countryName": "Colombia",
      "characterSets": [],
      "phoneCode": "+57"
    },
    "COM": {
      "countryName": "Comoros",
      "characterSets": [
        "arabic"
      ],
      "phoneCode": "+269"
    },
    "COG": {
      "countryName": "Congo",
      "characterSets": [],
      "phoneCode": "+242"
    },
    "COD": {
      "countryName": "Congo, the Democratic Republic of the",
      "characterSets": [],
      "phoneCode": "+243"
    },
    "COK": {
      "countryName": "Cook Islands",
      "characterSets": [],
      "phoneCode": "+682"
    },
    "CRI": {
      "countryName": "Costa Rica",
      "characterSets": [],
      "phoneCode": "+506"
    },
    "CIV": {
      "countryName": "Côte d'Ivoire",
      "characterSets": [],
      "phoneCode": "+225"
    },
    "HRV": {
      "countryName": "Croatia",
      "characterSets": [
        "latin-ext"
      ],
      "phoneCode": "+385"
    },
    "CUB": {
      "countryName": "Cuba",
      "characterSets": [],
      "phoneCode": "+53"
    },
    "CUW": {
      "countryName": "Curaçao",
      "characterSets": [],
      "phoneCode": "+599 9"
    },
    "CYP": {
      "countryName": "Cyprus",
      "characterSets": [],
      "phoneCode": "+357"
    },
    "CZE": {
      "countryName": "Czech Republic",
      "characterSets": [
        "latin-ext"
      ],
      "phoneCode": "+420"
    },
    "DNK": {
      "countryName": "Denmark",
      "characterSets": [],
      "phoneCode": "+45"
    },
    "DJI": {
      "countryName": "Djibouti",
      "characterSets": [
        "arabic"
      ],
      "phoneCode": "+253"
    },
    "DMA": {
      "countryName": "Dominica",
      "characterSets": [],
      "phoneCode": "+1 767"
    },
    "DOM": {
      "countryName": "Dominican Republic",
      "characterSets": [],
      "phoneCode": "+1 809"
    },
    "ECU": {
      "countryName": "Ecuador",
      "characterSets": [],
      "phoneCode": "+593"
    },
    "EGY": {
      "countryName": "Egypt",
      "characterSets": [
        "arabic"
      ],
      "phoneCode": "+20"
    },
    "SLV": {
      "countryName": "El Salvador",
      "characterSets": [],
      "phoneCode": "+503"
    },
    "GNQ": {
      "countryName": "Equatorial Guinea",
      "characterSets": [],
      "phoneCode": "+240"
    },
    "ERI": {
      "countryName": "Eritrea",
      "characterSets": [
        "arabic"
      ],
      "phoneCode": "+291"
    },
    "EST": {
      "countryName": "Estonia",
      "characterSets": [],
      "phoneCode": "+372"
    },
    "ETH": {
      "countryName": "Ethiopia",
      "characterSets": [],
      "phoneCode": "+251"
    },
    "FLK": {
      "countryName": "Falkland Islands (Malvinas)",
      "characterSets": [],
      "phoneCode": "+500"
    },
    "FRO": {
      "countryName": "Faroe Islands",
      "characterSets": [],
      "phoneCode": "+298"
    },
    "FJI": {
      "countryName": "Fiji",
      "characterSets": [],
      "phoneCode": "+679"
    },
    "FIN": {
      "countryName": "Finland",
      "characterSets": [],
      "phoneCode": "+358"
    },
    "FRA": {
      "countryName": "France",
      "characterSets": [],
      "phoneCode": "+33"
    },
    "GUF": {
      "countryName": "French Guiana",
      "characterSets": [],
      "phoneCode": "+594"
    },
    "PYF": {
      "countryName": "French Polynesia",
      "characterSets": [],
      "phoneCode": "+689"
    },
    "ATF": {
      "countryName": "French Southern Territories",
      "characterSets": [],
      "phoneCode": ""
    },
    "GAB": {
      "countryName": "Gabon",
      "characterSets": [],
      "phoneCode": "+241"
    },
    "GMB": {
      "countryName": "Gambia",
      "characterSets": [],
      "phoneCode": "+220"
    },
    "GEO": {
      "countryName": "Georgia",
      "characterSets": [],
      "phoneCode": "+995"
    },
    "DEU": {
      "countryName": "Germany",
      "characterSets": [],
      "phoneCode": "+49"
    },
    "GHA": {
      "countryName": "Ghana",
      "characterSets": [],
      "phoneCode": "+233"
    },
    "GIB": {
      "countryName": "Gibraltar",
      "characterSets": [],
      "phoneCode": "+350"
    },
    "GRC": {
      "countryName": "Greece",
      "characterSets": [],
      "phoneCode": "+30"
    },
    "GRL": {
      "countryName": "Greenland",
      "characterSets": [],
      "phoneCode": "+299"
    },
    "GRD": {
      "countryName": "Grenada",
      "characterSets": [],
      "phoneCode": "+1 473"
    },
    "GLP": {
      "countryName": "Guadeloupe",
      "characterSets": [],
      "phoneCode": "+590"
    },
    "GUM": {
      "countryName": "Guam",
      "characterSets": [],
      "phoneCode": "+1 671"
    },
    "GTM": {
      "countryName": "Guatemala",
      "characterSets": [],
      "phoneCode": "+502"
    },
    "GGY": {
      "countryName": "Guernsey",
      "characterSets": [],
      "phoneCode": "+44"
    },
    "GIN": {
      "countryName": "Guinea",
      "characterSets": [],
      "phoneCode": "+224"
    },
    "GNB": {
      "countryName": "Guinea-Bissau",
      "characterSets": [],
      "phoneCode": "+245"
    },
    "GUY": {
      "countryName": "Guyana",
      "characterSets": [],
      "phoneCode": "+592"
    },
    "HTI": {
      "countryName": "Haiti",
      "characterSets": [],
      "phoneCode": "+509"
    },
    "HMD": {
      "countryName": "Heard Island and McDonald Islands",
      "characterSets": [],
      "phoneCode": ""
    },
    "VAT": {
      "countryName": "Holy See (Vatican City State)",
      "characterSets": [],
      "phoneCode": ""
    },
    "HND": {
      "countryName": "Honduras",
      "characterSets": [],
      "phoneCode": "+504"
    },
    "HKG": {
      "countryName": "Hong Kong",
      "characterSets": [],
      "phoneCode": "+852"
    },
    "HUN": {
      "countryName": "Hungary",
      "characterSets": [
        "latin-ext"
      ],
      "phoneCode": "+36"
    },
    "ISL": {
      "countryName": "Iceland",
      "characterSets": [],
      "phoneCode": "+354"
    },
    "IND": {
      "countryName": "India",
      "characterSets": [],
      "phoneCode": "+91"
    },
    "IDN": {
      "countryName": "Indonesia",
      "characterSets": [],
      "phoneCode": "+62"
    },
    "IRN": {
      "countryName": "Iran, Islamic Republic of",
      "characterSets": [],
      "phoneCode": "+98"
    },
    "IRQ": {
      "countryName": "Iraq",
      "characterSets": [
        "arabic"
      ],
      "phoneCode": "+964"
    },
    "IRL": {
      "countryName": "Ireland",
      "characterSets": [],
      "phoneCode": "+353"
    },
    "IMN": {
      "countryName": "Isle of Man",
      "characterSets": [],
      "phoneCode": "+44"
    },
    "ISR": {
      "countryName": "Israel",
      "characterSets": [
        "hebrew",
        "arabic"
      ],
      "phoneCode": "+972"
    },
    "ITA": {
      "countryName": "Italy",
      "characterSets": [],
      "phoneCode": "+39"
    },
    "JAM": {
      "countryName": "Jamaica",
      "characterSets": [],
      "phoneCode": "+1 876"
    },
    "JPN": {
      "countryName": "Japan",
      "characterSets": [
        "japanese"
      ],
      "phoneCode": "+81"
    },
    "JEY": {
      "countryName": "Jersey",
      "characterSets": [],
      "phoneCode": "+44"
    },
    "JOR": {
      "countryName": "Jordan",
      "characterSets": [
        "arabic"
      ],
      "phoneCode": "+962"
    },
    "KAZ": {
      "countryName": "Kazakhstan",
      "characterSets": [],
      "phoneCode": "+7"
    },
    "KEN": {
      "countryName": "Kenya",
      "characterSets": [],
      "phoneCode": "+254"
    },
    "KIR": {
      "countryName": "Kiribati",
      "characterSets": [],
      "phoneCode": "+686"
    },
    "PRK": {
      "countryName": "Korea, Democratic People's Republic of",
      "characterSets": [
        "korean"
      ],
      "phoneCode": "+850"
    },
    "KOR": {
      "countryName": "Korea, Republic of",
      "characterSets": [
        "korean"
      ],
      "phoneCode": "+82"
    },
    "KWT": {
      "countryName": "Kuwait",
      "characterSets": [
        "arabic"
      ],
      "phoneCode": "+965"
    },
    "KGZ": {
      "countryName": "Kyrgyzstan",
      "characterSets": [],
      "phoneCode": "+996"
    },
    "LAO": {
      "countryName": "Lao People's Democratic Republic",
      "characterSets": [],
      "phoneCode": "+856"
    },
    "LVA": {
      "countryName": "Latvia",
      "characterSets": [
        "latin-ext"
      ],
      "phoneCode": "+371"
    },
    "LBN": {
      "countryName": "Lebanon",
      "characterSets": [
        "arabic"
      ],
      "phoneCode": "+961"
    },
    "LSO": {
      "countryName": "Lesotho",
      "characterSets": [],
      "phoneCode": "+266"
    },
    "LBR": {
      "countryName": "Liberia",
      "characterSets": [],
      "phoneCode": "+231"
    },
    "LBY": {
      "countryName": "Libya",
      "characterSets": [
        "arabic"
      ],
      "phoneCode": "+218"
    },
    "LIE": {
      "countryName": "Liechtenstein",
      "characterSets": [],
      "phoneCode": "+423"
    },
    "LTU": {
      "countryName": "Lithuania",
      "characterSets": [],
      "phoneCode": "+370"
    },
    "LUX": {
      "countryName": "Luxembourg",
      "characterSets": [],
      "phoneCode": "+352"
    },
    "MAC": {
      "countryName": "Macao",
      "characterSets": [],
      "phoneCode": "+853"
    },
    "MKD": {
      "countryName": "Macedonia, the former Yugoslav Republic of",
      "characterSets": [
        "cyrillic"
      ],
      "phoneCode": "+389"
    },
    "MDG": {
      "countryName": "Madagascar",
      "characterSets": [],
      "phoneCode": "+261"
    },
    "MWI": {
      "countryName": "Malawi",
      "characterSets": [],
      "phoneCode": "+265"
    },
    "MYS": {
      "countryName": "Malaysia",
      "characterSets": [],
      "phoneCode": "+60"
    },
    "MDV": {
      "countryName": "Maldives",
      "characterSets": [],
      "phoneCode": "+960"
    },
    "MLI": {
      "countryName": "Mali",
      "characterSets": [],
      "phoneCode": "+223"
    },
    "MLT": {
      "countryName": "Malta",
      "characterSets": [],
      "phoneCode": "+356"
    },
    "MHL": {
      "countryName": "Marshall Islands",
      "characterSets": [],
      "phoneCode": "+692"
    },
    "MTQ": {
      "countryName": "Martinique",
      "characterSets": [],
      "phoneCode": "+596"
    },
    "MRT": {
      "countryName": "Mauritania",
      "characterSets": [
        "arabic"
      ],
      "phoneCode": "+222"
    },
    "MUS": {
      "countryName": "Mauritius",
      "characterSets": [],
      "phoneCode": "+230"
    },
    "MYT": {
      "countryName": "Mayotte",
      "characterSets": [],
      "phoneCode": "+262"
    },
    "MEX": {
      "countryName": "Mexico",
      "characterSets": [],
      "phoneCode": "+52"
    },
    "FSM": {
      "countryName": "Micronesia, Federated States of",
      "characterSets": [],
      "phoneCode": "+691"
    },
    "MDA": {
      "countryName": "Moldova, Republic of",
      "characterSets": [],
      "phoneCode": "+373"
    },
    "MCO": {
      "countryName": "Monaco",
      "characterSets": [],
      "phoneCode": "+377"
    },
    "MNG": {
      "countryName": "Mongolia",
      "characterSets": [],
      "phoneCode": "+976"
    },
    "MNE": {
      "countryName": "Montenegro",
      "characterSets": [
        "cyrillic"
      ],
      "phoneCode": "+382"
    },
    "MSR": {
      "countryName": "Montserrat",
      "characterSets": [],
      "phoneCode": "+1 664"
    },
    "MAR": {
      "countryName": "Morocco",
      "characterSets": [
        "arabic"
      ],
      "phoneCode": "+212"
    },
    "MOZ": {
      "countryName": "Mozambique",
      "characterSets": [],
      "phoneCode": "+258"
    },
    "MMR": {
      "countryName": "Myanmar",
      "characterSets": [],
      "phoneCode": ""
    },
    "NAM": {
      "countryName": "Namibia",
      "characterSets": [],
      "phoneCode": "+264"
    },
    "NRU": {
      "countryName": "Nauru",
      "characterSets": [],
      "phoneCode": "+674"
    },
    "NPL": {
      "countryName": "Nepal",
      "characterSets": [],
      "phoneCode": "+977"
    },
    "NLD": {
      "countryName": "Netherlands",
      "characterSets": [],
      "phoneCode": "+31"
    },
    "NCL": {
      "countryName": "New Caledonia",
      "characterSets": [],
      "phoneCode": "+687"
    },
    "NZL": {
      "countryName": "New Zealand",
      "characterSets": [],
      "phoneCode": "+64"
    },
    "NIC": {
      "countryName": "Nicaragua",
      "characterSets": [],
      "phoneCode": "+505"
    },
    "NER": {
      "countryName": "Niger",
      "characterSets": [],
      "phoneCode": "+227"
    },
    "NGA": {
      "countryName": "Nigeria",
      "characterSets": [],
      "phoneCode": "+234"
    },
    "NIU": {
      "countryName": "Niue",
      "characterSets": [],
      "phoneCode": "+683"
    },
    "NFK": {
      "countryName": "Norfolk Island",
      "characterSets": [],
      "phoneCode": "+672"
    },
    "MNP": {
      "countryName": "Northern Mariana Islands",
      "characterSets": [],
      "phoneCode": "+1 670"
    },
    "NOR": {
      "countryName": "Norway",
      "characterSets": [],
      "phoneCode": "+47"
    },
    "OMN": {
      "countryName": "Oman",
      "characterSets": [
        "arabic"
      ],
      "phoneCode": "+968"
    },
    "PAK": {
      "countryName": "Pakistan",
      "characterSets": [],
      "phoneCode": "+92"
    },
    "PLW": {
      "countryName": "Palau",
      "characterSets": [],
      "phoneCode": "+680"
    },
    "PSE": {
      "countryName": "Palestine, State of",
      "characterSets": [
        "arabic"
      ],
      "phoneCode": "+970"
    },
    "PAN": {
      "countryName": "Panama",
      "characterSets": [],
      "phoneCode": "+507"
    },
    "PNG": {
      "countryName": "Papua New Guinea",
      "characterSets": [],
      "phoneCode": "+675"
    },
    "PRY": {
      "countryName": "Paraguay",
      "characterSets": [],
      "phoneCode": "+595"
    },
    "PER": {
      "countryName": "Peru",
      "characterSets": [],
      "phoneCode": "+51"
    },
    "PHL": {
      "countryName": "Philippines",
      "characterSets": [],
      "phoneCode": "+63"
    },
    "PCN": {
      "countryName": "Pitcairn",
      "characterSets": [],
      "phoneCode": "+64"
    },
    "POL": {
      "countryName": "Poland",
      "characterSets": [
        "latin-ext"
      ],
      "phoneCode": "+48"
    },
    "PRT": {
      "countryName": "Portugal",
      "characterSets": [],
      "phoneCode": "+351"
    },
    "PRI": {
      "countryName": "Puerto Rico",
      "characterSets": [],
      "phoneCode": "+1 787"
    },
    "QAT": {
      "countryName": "Qatar",
      "characterSets": [
        "arabic"
      ],
      "phoneCode": "+974"
    },
    "REU": {
      "countryName": "Réunion",
      "characterSets": [],
      "phoneCode": "+262"
    },
    "ROU": {
      "countryName": "Romania",
      "characterSets": [
        "latin-ext"
      ],
      "phoneCode": "+40"
    },
    "RUS": {
      "countryName": "Russian Federation",
      "characterSets": [
        "cyrillic"
      ],
      "phoneCode": "+7"
    },
    "RWA": {
      "countryName": "Rwanda",
      "characterSets": [],
      "phoneCode": "+250"
    },
    "BLM": {
      "countryName": "Saint Barthélemy",
      "characterSets": [],
      "phoneCode": "+590"
    },
    "SHN": {
      "countryName": "Saint Helena, Ascension and Tristan da Cunha",
      "characterSets": [],
      "phoneCode": "+290"
    },
    "KNA": {
      "countryName": "Saint Kitts and Nevis",
      "characterSets": [],
      "phoneCode": "+1 869"
    },
    "LCA": {
      "countryName": "Saint Lucia",
      "characterSets": [],
      "phoneCode": "+1 758"
    },
    "MAF": {
      "countryName": "Saint Martin (French part)",
      "characterSets": [],
      "phoneCode": "+590"
    },
    "SPM": {
      "countryName": "Saint Pierre and Miquelon",
      "characterSets": [],
      "phoneCode": "+508"
    },
    "VCT": {
      "countryName": "Saint Vincent and the Grenadines",
      "characterSets": [],
      "phoneCode": "+1 784"
    },
    "WSM": {
      "countryName": "Samoa",
      "characterSets": [],
      "phoneCode": "+685"
    },
    "SMR": {
      "countryName": "San Marino",
      "characterSets": [],
      "phoneCode": "+378"
    },
    "STP": {
      "countryName": "Sao Tome and Principe",
      "characterSets": [],
      "phoneCode": "+239"
    },
    "SAU": {
      "countryName": "Saudi Arabia",
      "characterSets": [
        "arabic"
      ],
      "phoneCode": "+966"
    },
    "SEN": {
      "countryName": "Senegal",
      "characterSets": [],
      "phoneCode": "+221"
    },
    "SRB": {
      "countryName": "Serbia",
      "characterSets": [
        "cyrillic"
      ],
      "phoneCode": "+381"
    },
    "SYC": {
      "countryName": "Seychelles",
      "characterSets": [],
      "phoneCode": "+248"
    },
    "SLE": {
      "countryName": "Sierra Leone",
      "characterSets": [],
      "phoneCode": "+232"
    },
    "SGP": {
      "countryName": "Singapore",
      "characterSets": [],
      "phoneCode": "+65"
    },
    "SXM": {
      "countryName": "Sint Maarten (Dutch part)",
      "characterSets": [],
      "phoneCode": "+1 721"
    },
    "SVK": {
      "countryName": "Slovakia",
      "characterSets": [],
      "phoneCode": "+421"
    },
    "SVN": {
      "countryName": "Slovenia",
      "characterSets": [],
      "phoneCode": "+386"
    },
    "SLB": {
      "countryName": "Solomon Islands",
      "characterSets": [],
      "phoneCode": "+677"
    },
    "SOM": {
      "countryName": "Somalia",
      "characterSets": [
        "arabic"
      ],
      "phoneCode": "+252"
    },
    "ZAF": {
      "countryName": "South Africa",
      "characterSets": [],
      "phoneCode": "+27"
    },
    "SGS": {
      "countryName": "South Georgia and the South Sandwich Islands",
      "characterSets": [],
      "phoneCode": "+500"
    },
    "SSD": {
      "countryName": "South Sudan",
      "characterSets": [],
      "phoneCode": "+211"
    },
    "ESP": {
      "countryName": "Spain",
      "characterSets": [],
      "phoneCode": "+34"
    },
    "LKA": {
      "countryName": "Sri Lanka",
      "characterSets": [],
      "phoneCode": "+94"
    },
    "SDN": {
      "countryName": "Sudan",
      "characterSets": [
        "arabic"
      ],
      "phoneCode": "+249"
    },
    "SUR": {
      "countryName": "Suriname",
      "characterSets": [],
      "phoneCode": "+597"
    },
    "SJM": {
      "countryName": "Svalbard and Jan Mayen",
      "characterSets": [],
      "phoneCode": "+47 79"
    },
    "SWZ": {
      "countryName": "Swaziland",
      "characterSets": [],
      "phoneCode": "+268"
    },
    "SWE": {
      "countryName": "Sweden",
      "characterSets": [],
      "phoneCode": "+46"
    },
    "CHE": {
      "countryName": "Switzerland",
      "characterSets": [],
      "phoneCode": "+41"
    },
    "SYR": {
      "countryName": "Syrian Arab Republic",
      "characterSets": [
        "arabic"
      ],
      "phoneCode": "+963"
    },
    "TWN": {
      "countryName": "Taiwan, Province of China",
      "characterSets": [],
      "phoneCode": "+886"
    },
    "TJK": {
      "countryName": "Tajikistan",
      "characterSets": [],
      "phoneCode": "+992"
    },
    "TZA": {
      "countryName": "Tanzania, United Republic of",
      "characterSets": [],
      "phoneCode": "+255"
    },
    "THA": {
      "countryName": "Thailand",
      "characterSets": [],
      "phoneCode": "+66"
    },
    "TLS": {
      "countryName": "Timor-Leste",
      "characterSets": [],
      "phoneCode": ""
    },
    "TGO": {
      "countryName": "Togo",
      "characterSets": [],
      "phoneCode": "+228"
    },
    "TKL": {
      "countryName": "Tokelau",
      "characterSets": [],
      "phoneCode": "+690"
    },
    "TON": {
      "countryName": "Tonga",
      "characterSets": [],
      "phoneCode": "+676"
    },
    "TTO": {
      "countryName": "Trinidad and Tobago",
      "characterSets": [],
      "phoneCode": "+1 868"
    },
    "TUN": {
      "countryName": "Tunisia",
      "characterSets": [
        "arabic"
      ],
      "phoneCode": "+216"
    },
    "TUR": {
      "countryName": "Turkey",
      "characterSets": [
        "latin-ext"
      ],
      "phoneCode": "+90"
    },
    "TKM": {
      "countryName": "Turkmenistan",
      "characterSets": [],
      "phoneCode": "+993"
    },
    "TCA": {
      "countryName": "Turks and Caicos Islands",
      "characterSets": [],
      "phoneCode": "+1 649"
    },
    "TUV": {
      "countryName": "Tuvalu",
      "characterSets": [],
      "phoneCode": "+688"
    },
    "UGA": {
      "countryName": "Uganda",
      "characterSets": [],
      "phoneCode": "+256"
    },
    "UKR": {
      "countryName": "Ukraine",
      "characterSets": [
        "cyrillic"
      ],
      "phoneCode": "+380"
    },
    "ARE": {
      "countryName": "United Arab Emirates",
      "characterSets": [
        "arabic"
      ],
      "phoneCode": "+971"
    },
    "GBR": {
      "countryName": "United Kingdom",
      "characterSets": [],
      "phoneCode": "+44"
    },
    "USA": {
      "countryName": "United States",
      "characterSets": [],
      "phoneCode": "+1"
    },
    "UMI": {
      "countryName": "United States Minor Outlying Islands",
      "characterSets": [],
      "phoneCode": ""
    },
    "URY": {
      "countryName": "Uruguay",
      "characterSets": [],
      "phoneCode": "+598"
    },
    "UZB": {
      "countryName": "Uzbekistan",
      "characterSets": [],
      "phoneCode": "+998"
    },
    "VUT": {
      "countryName": "Vanuatu",
      "characterSets": [],
      "phoneCode": "+678"
    },
    "VEN": {
      "countryName": "Venezuela, Bolivarian Republic of",
      "characterSets": [],
      "phoneCode": "+58"
    },
    "VNM": {
      "countryName": "Viet Nam",
      "characterSets": [],
      "phoneCode": "+84"
    },
    "VGB": {
      "countryName": "Virgin Islands, British",
      "characterSets": [],
      "phoneCode": ""
    },
    "VIR": {
      "countryName": "Virgin Islands, U.S.",
      "characterSets": [],
      "phoneCode": ""
    },
    "WLF": {
      "countryName": "Wallis and Futuna",
      "characterSets": [],
      "phoneCode": "+681"
    },
    "ESH": {
      "countryName": "Western Sahara",
      "characterSets": [],
      "phoneCode": ""
    },
    "YEM": {
      "countryName": "Yemen",
      "characterSets": [
        "arabic"
      ],
      "phoneCode": "+967"
    },
    "ZMB": {
      "countryName": "Zambia",
      "characterSets": [],
      "phoneCode": "+260"
    },
    "ZWE": {
      "countryName": "Zimbabwe",
      "characterSets": [],
      "phoneCode": "+263"
    }
  }
}
